import { render, staticRenderFns } from "./DormitoryHistory.vue?vue&type=template&id=9e458a3c&scoped=true"
import script from "./DormitoryHistory.vue?vue&type=script&lang=js"
export * from "./DormitoryHistory.vue?vue&type=script&lang=js"
import style0 from "./DormitoryHistory.vue?vue&type=style&index=0&id=9e458a3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e458a3c",
  null
  
)

export default component.exports